import { render } from "./tab.vue?vue&type=template&id=29ee6287&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"

import "./tab.vue?vue&type=style&index=0&id=29ee6287&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ee6287"],['__file',"src/components/notepad/tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29ee6287"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29ee6287', __exports__)) {
    api.reload('29ee6287', __exports__)
  }
  
  module.hot.accept("./tab.vue?vue&type=template&id=29ee6287&scoped=true", () => {
    api.rerender('29ee6287', render)
  })

}


export default __exports__